.SuccessDialog_content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 23rem;
}

.SuccessDialog_chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.SuccessDialog_claims {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.25rem;
}
